module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_t-956eb077ff717b7c5fc6ce4fa5f43b12.gif";